import { render, staticRenderFns } from "./ChatPreviewImage.vue?vue&type=template&id=42734757"
import script from "./ChatPreviewImage.vue?vue&type=script&lang=js"
export * from "./ChatPreviewImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports